//
//
import { call, put, takeEvery } from "redux-saga/effects"

import { CREDENCIALES_LISTA_CREDENCIALES } from "./actionTypes"

import {
  getCredencialesListaCredencialesSuccess,
  getCredencialesListaCredencialesFail,
} from "./actions"

import { getListaCredenciales } from "../../helpers/campusvirtualbackend_helper"

function* fetchCredencialesList({ payload: { jsonparameters } }) {
  try {
    const response = yield call(getListaCredenciales, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaAlumnos:Fail: ", response)
      yield put(getCredencialesListaCredencialesFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCajaAlumnos:success: ", response)
      yield put(getCredencialesListaCredencialesSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaAlumnos::Eror: " + error)
    yield put(getCredencialesListaCredencialesFail(error))
  }
}

function* CredencialesSaga() {
  yield takeEvery(CREDENCIALES_LISTA_CREDENCIALES, fetchCredencialesList)
}

export default CredencialesSaga
